import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, onMounted } from 'vue'
import type { PropType } from 'vue'
import Network from '@/Network'
import { useErrorToast } from '@/composables/useErrorToast'
import { DsPolicySearchParams } from '@/Network/Types/Requests/DsPolicyRequests'
import type {
  PolicyOptionItem,
  PolicyOptionsFetcher
} from '@/components/designSystem/PolicyLinksManager/types'

const limit = 30

export default /*#__PURE__*/_defineComponent({
  __name: 'DsPolicySelect',
  props: {
  modelValue: [String, Number, Object],
  companyId: Number,
  // Fonte alternativa de opções (ex: políticas de repasse). Sem ela, usa Network.policy.list
  fetchPolicies: {
    type: Function as PropType<PolicyOptionsFetcher>,
    required: false,
    default: undefined
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;



const { notifyError } = useErrorToast()

const model = ref(props.modelValue)
const policies = ref<PolicyOptionItem[]>([])
const isLoading = ref(false)
const searchTerm = ref('')
const offset = ref(0)
const allLoaded = ref(false)

watch(
  () => props.modelValue,
  (val) => (model.value = val)
)
watch(
  () => model.value,
  (val) => emit('update:modelValue', val)
)

const onSearch = async (search: string) => {
  searchTerm.value = search
  offset.value = 0
  policies.value = []
  allLoaded.value = false
  await fetchDsPolicies()
}

const appendPage = (newItems: PolicyOptionItem[]) => {
  if (newItems.length < limit) allLoaded.value = true

  const existingIds = new Set(policies.value.map((p) => p.id))
  const uniqueItems = newItems.filter((item) => !existingIds.has(item.id))

  policies.value.push(...uniqueItems)
  offset.value += limit
}

const fetchDsPolicies = async () => {
  if (isLoading.value || allLoaded.value) return

  isLoading.value = true
  try {
    if (props.fetchPolicies) {
      const items = await props.fetchPolicies({
        q: searchTerm.value,
        companyId: props.companyId,
        offset: offset.value,
        limit
      })
      appendPage(items)
      return
    }

    const filters: DsPolicySearchParams = {
      q: searchTerm.value,
      isActive: true,
      limit: 0,
      offset: 0
    }

    if (props.companyId) {
      filters.companyIds = `${props.companyId}`
    }

    const response = await Network.policy.list(filters)

    appendPage(response?.data ?? [])
  } catch (error) {
    // Sem o aviso o select mostrava "Nenhuma política encontrada", como se não houvesse.
    notifyError(error, 'Não foi possível carregar as políticas.')
  } finally {
    isLoading.value = false
  }
}

const onScroll = (event: Event) => {
  const target = event.target as HTMLElement
  if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
    fetchDsPolicies()
  }
}

onMounted(() => {
  fetchDsPolicies()
})

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    class: "w-full",
    color: "primary20",
    label: "Buscar Política *",
    theme: "light",
    items: policies.value,
    "item-title": "name",
    "item-value": "id",
    "return-object": "",
    density: "comfortable",
    loading: isLoading.value,
    variant: "outlined",
    "hide-details": "",
    "no-data-text": "Nenhuma política encontrada",
    "onUpdate:search": onSearch,
    onScrollPassive: onScroll
  }, {
    item: _withCtx(({ props, item }) => [
      _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_list_item_subtitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.company?.name), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040)
    ]),
    _: 1
  }, 8, ["modelValue", "items", "loading"]))
}
}

})